import React from "react";

import DuoErrorScreen, { DuoErrorType } from "components/DuoErrorScreen";
import { HttpResponseError } from "util/errors";

/**
 * Convert an HTTP error status code from a Release Dashboard Backend request to a `DuoErrorType`.
 *
 * @param status The status code to convert.
 * @returns An appropriate `DuoErrorType`.
 */
const statusToErrorType = (status: number) => {
  if (status === 401 || status === 403) {
    return DuoErrorType.PermissionDenied;
  }
  if (status >= 500) {
    return DuoErrorType.ServerError;
  }
  return DuoErrorType.UnknownError;
};

const useErrorScreen = (isError: boolean, error: unknown) => {
  if (isError) {
    if (error instanceof HttpResponseError) {
      const duoErrorType = statusToErrorType(error.status);
      return <DuoErrorScreen error={error} errorType={duoErrorType} />;
    }
    return (
      <DuoErrorScreen error={error} errorType={DuoErrorType.UnknownError} />
    );
  }
  return null;
};

export default useErrorScreen;
